import React from 'react';

const STAT_CONFIGS = [
  { key: 'total', label: 'Total Applications', color: '#0B1F3B', icon: 'M9 12h6M9 16h6M9 8h6M5 4h14a1 1 0 011 1v14a1 1 0 01-1 1H5a1 1 0 01-1-1V5a1 1 0 011-1z' },
  { key: 'pending', label: 'Pending Review', color: '#D4A520', icon: 'M12 8v4l3 3M12 3a9 9 0 100 18A9 9 0 0012 3z' },
  { key: 'approved', label: 'Approved', color: '#059669', icon: 'M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z' },
  { key: 'thisWeek', label: 'This Week', color: '#7C3AED', icon: 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z' },
];

export default function StatsRow({ stats }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {STAT_CONFIGS?.map(({ key, label, color, icon }) => (
        <div key={key} className="bg-white rounded-xl p-5 border border-gray-100 shadow-sm">
          <div className="flex items-center justify-between mb-3">
            <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: `${color}15` }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d={icon} stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </div>
          <p className="text-2xl font-bold" style={{ color }}>{stats?.[key]}</p>
          <p className="text-xs font-medium mt-0.5" style={{ color: '#6B7280' }}>{label}</p>
        </div>
      ))}
    </div>
  );
}
